import backofficeService from '@/api/backoffice'

export default {
  getAll(params) {
    return backofficeService.Api().get('dayEnd', { params }).then(response => response.data)
  },
  getById(id, params) {
    return backofficeService.Api().get(`dayEnd/${encodeURIComponent(id)}`, { params }).then(response => response.data)
  },
}
